// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sj-6";
export var imgContainer = "_sj-3";
export var menuIcon = "_sj-5";
export var pillWrapper = "_sj-2";
export var pillsContainer = "_sj-1";
export var subscriptionCard = "_sj-0";
export var subscriptionLogo = "_sj-4";